module.exports = __webpack_public_path__ + "images/graphic-header-mobile_9d9e78bdd937394145280090019e748d.png";